/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LinkButtonComponentDisplay } from "cms/components/components/link-button/display";
import { LinkButtonComponentEditor } from "cms/components/components/link-button/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const LinkButtonComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <LinkButtonComponentDisplay />,
        editComponent: <LinkButtonComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

LinkButtonComponent.displayName = "LinkButtonComponent";
export { LinkButtonComponent };
